import React from 'react';
import { ArrowUpRight } from '../ArrowUpRight/ArrowUpRight';

export function PersonalProjects() {
  return (
    <section className="background-section" aria-labelledby="projects-title">
      <div className="section-heading">
        <p className="eyebrow">Outside of work</p>
        <h2 id="projects-title">Personal projects</h2>
      </div>
      <div className="project-grid">
        <article className="project-card portfolio-project">
          <div className="project-art portfolio-art" aria-hidden="true">
            <div className="mini-browser">
              <div className="browser-bar">
                <i />
                <i />
                <i />
                <span>kyle-herrmann.app</span>
              </div>
              <div className="mini-page">
                <strong>kh<span>.</span>
                </strong>
                <div className="mini-lines">
                  <i />
                  <i />
                  <i />
                </div>
              </div>
            </div>
          </div>
          <div className="project-body">
            <p className="project-meta">01 / Web <span>Ongoing</span>
            </p>
            <h3>This portfolio</h3>
            <p>A personal space for my work and the projects behind it. Originally built in React, now evolving alongside my career.</p>
            <div className="project-bottom">
              <span>React · TypeScript · CSS</span>
              <span className="project-here">You’re here</span>
            </div>
          </div>
        </article>
        <article className="project-card chess-project">
          <div className="project-art chess-art" aria-hidden="true">
            <div className="chess-board">{Array.from({ length: 64 }, (_, i) => <i key={i} className={(Math.floor(i / 8) + i % 8) % 2 ? 'dark-square' : ''} />)}</div>
            <span className="chess-piece">♞</span>
            <span className="art-caption">JavaFX / 2019</span>
          </div>
          <div className="project-body">
            <p className="project-meta">02 / Desktop <span>2019</span>
            </p>
            <h3>JavaFX Chess</h3>
            <p>An early project in building a complete game with Java and JavaFX.</p>
            <div className="project-bottom">
              <span>Java · JavaFX · 3D</span>
              <a href="https://github.com/kyle-herrmann/javafx-chess" target="_blank" rel="noreferrer">View source <span aria-hidden="true"><ArrowUpRight /></span>
              </a>
            </div>
          </div>
        </article>
        <article className="arcade-project">
          <div className="arcade-art" aria-hidden="true">
            <svg viewBox="0 0 120 90" fill="none">
              <path d="M60 10 86 70 60 57 34 70Z" stroke="currentColor" strokeWidth="1.5" />
              <path d="m51 68 9 13 9-13M60 10v47M15 22v7m-3-3h6m79 16v7m-3-3h6M90 10v4M20 69v4" stroke="currentColor" />
            </svg>
          </div>
          <div>
            <p className="project-meta">03 / Game development</p>
            <h3>3D arcade space shooter</h3>
            <p>A personal game project exploring 3D arcade gameplay in Swift.</p>
          </div>
          <span className="arcade-stack">Swift · 3D</span>
        </article>
      </div>
      <div className="education-row">
        <p className="eyebrow">Education</p>
        <div>
          <h3>British Columbia Institute of Technology</h3>
          <p>
            <a className="education-link" href="https://www.bcit.ca/programs/computer-systems-certificate-part-time-5500cert/" target="_blank" rel="noreferrer">Computer Systems · Certificate <span aria-hidden="true"><ArrowUpRight /></span>
            </a>
          </p>
        </div>
        <span>September 2019 — January 2021</span>
      </div>
    </section>
  );
}
